// Query-key prefixes whose cached data must be dropped when the PIN lock
// engages, so a locked finance section leaves nothing sensitive in memory.
// The hub summary ('hub'), agenda, lists, and settings caches are
// intentionally NOT listed — those routes stay accessible while locked.
import type { QueryClient } from '@tanstack/react-query';

export const FINANCIAL_QUERY_KEYS = [
  'expenses',
  'deposits',
  'bills',
  'billFiles',
  'dashboard',
  'reports',
  'investments',
  'portfolio-timeline',
  'snapshots',
  'accounts',
  'categories',
  'category-suggestion',
] as const;

export function clearFinancialQueries(queryClient: QueryClient): void {
  for (const key of FINANCIAL_QUERY_KEYS) {
    queryClient.removeQueries({ queryKey: [key] });
  }
}
